<template>
  <div class="container">
    <!-- 背景，和全项目页面保持一致 -->
    <div class="footprint-bg" :style="{backgroundImage: `url(${bgImg})`}"></div>

    <div class="header">
      <button class="back-btn" @click="goBack">返回首页</button>
      <h2>个人中心</h2>
    </div>

    <!-- ========== 豆腐块网格容器 ========== -->
    <div class="block-container">
      <!-- 豆腐块1：个人资料（独立置于上方） -->
      <div class="block-item block-user block-user-full">
        <!-- 里面的内容完全不动 -->
        <div class="user-card">
          <div class="avatar-box" @click="openAvatarUpload">
            <img class="avatar" :src="userInfo.avatar || '/default-avatar.webp'" alt="avatar" />
            <div class="avatar-mask">更换头像</div>
          </div>
          <div class="user-info">
            <div class="info-row">
              <div class="username" @click="openNameEdit">{{ userInfo.nickname }}</div>
              <button class="annual-report-btn" @click="goToAnnualReport">年度印记报告</button>
              <button class="export-entry-btn" @click="openExportModal">导出足迹数据</button>
            </div>
            <div class="info-row">
              <span class="user-desc" @click="openDescEdit">{{ userInfo.signature }}</span>
              <span class="tip-text-profile">点击对应个人资料可编辑</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 👇 新增包裹层：包含下面 6 个块，绝对均分 -->
      <div class="block-grid-6">
        <!-- 豆腐块2：个人足迹 -->
        <div class="block-item block-footprint" @click="goPersonalFootprint">
          <div class="block-title">个人足迹</div>
          <div class="block-desc">独行天地，山河为凭。<br>每一步，皆是你与世界亲近的私语。</div>
        </div>

        <!-- 豆腐块3：我创建的小组 -->
        <div class="block-item block-group-leader">
            <div class="group-btn-wrap">
            <button class="group-enter-btn" @click="goGroupCreatedListPage">我创建的小组</button>
            <button class="create-group-btn" @click="openCreateGroupModal">创建小组</button>
          </div>
        </div>

        <!-- 豆腐块4：我加入的小组 -->
        <div class="block-item block-group-member">
          <div class="group-btn-wrap">
            <button class="group-enter-btn" @click="goGroupJoinedListPage">我加入的小组</button>
            <button class="join-group-btn" @click="openJoinGroupModal">加入小组</button>
          </div>
        </div>

        <!-- 豆腐块5：足迹统计 -->
        <div class="block-item block-stat" @click="goStat">
          <div class="block-title">足迹统计</div>
          <div class="block-desc">行遍九州，灯火入图。<br>所至之处，山河有光，人间成诗。</div>
        </div>

        <!-- 豆腐块6：足迹海报 & 纪念日 -->
        <div class="block-item block-poster">
          <div class="group-btn-wrap">
            <!-- 上半部分：足迹海报 -->
            <button class="group-enter-btn" @click="goPoster" style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 4px; gap: 2px;">
              <!-- 👇 加上 text-align: center 和 width: 100% 让文字居中，自动换行 -->
              <span style="font-size: clamp(12px, 1.2vw, 16px); font-weight: 600; line-height: 1.2;">足迹海报</span>
              <span style="font-size: clamp(9px, 0.8vw, 11px); color: rgba(255,255,255,0.85); font-weight: normal; letter-spacing: 0; text-align: center; width: 100%; line-height: 1.2;">千山万水，凝于一纸；晨昏四季，收于方寸。</span>
            </button>
            
            <!-- 下半部分：纪念日 -->
            <button class="group-enter-btn" @click="goAnniversary" style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 4px; gap: 2px;">
              <span style="font-size: clamp(12px, 1.2vw, 16px); font-weight: 600; line-height: 1.2;">纪念日</span>
              <span style="font-size: clamp(9px, 0.8vw, 11px); color: rgba(255,255,255,0.85); font-weight: normal; letter-spacing: 0; text-align: center; width: 100%; line-height: 1.2;">寻常千日，皆为铺垫；只此一日，方作落款。</span>
            </button>
          </div>
        </div>

<!-- 豆腐块7：岁月长卷 -->
<div class="block-item block-video" @click="goMemories">
  <div class="block-title">岁月长卷</div>
  <div class="block-desc">岁月印记，往事成行。<br>回望处，山河如故，人亦如初。</div>
</div>
      </div> <!-- block-grid-6 结束 -->
    </div> <!-- block-container 结束 -->

    <!-- 隐藏头像上传input【全部原有弹窗保留，位置不变】 -->
    <input ref="avatarInput" type="file" accept="image/png,image/jpeg" style="display:none" @change="handleAvatarChange" />

    <!-- 弹窗：修改昵称 -->
    <div v-if="showNameModal" class="modal-mask" @click.self="closeNameModal">
      <div class="modal-box">
        <h3>修改昵称</h3>
        <input v-model="tempNickname" type="text" placeholder="2~12个字，中英文数字下划线" />
        <div class="tip-text">昵称2-12字符，禁止特殊敏感字符</div>
        <div class="btn-group">
          <button @click="closeNameModal">取消</button>
          <button @click="saveNickname">保存</button>
        </div>
      </div>
    </div>

    <!-- 弹窗：修改个性签名 -->
    <div v-if="showDescModal" class="modal-mask" @click.self="closeDescModal">
      <div class="modal-box">
        <h3>修改个性签名</h3>
        <textarea class="sig-textarea" v-model="tempSignature" placeholder="最多15个字"></textarea>
        <div class="tip-text">签名最多15字，禁止违规内容</div>
        <div class="btn-group">
          <button @click="closeDescModal">取消</button>
          <button @click="saveSignature">保存</button>
        </div>
      </div>
    </div>

     <!-- 创建小组弹窗【✅已调整顺序：小组名称放最顶部 必填*】 -->
<div v-if="showCreateGroupModal" class="modal-mask" @click.self="closeCreateGroupModal">
  <div class="modal-box">
    <h3>创建小组</h3>
    <!-- ========== 改动：一行放小组名称 + 小组人数 ========== -->
    <div class="form-row-two">
  <div class="form-item">
    <label>小组名称 <span style="color:red">*</span></label>
    <input
      v-model="createGroupForm.groupName"
      type="text"
      maxlength="6"
      placeholder="最多6个字符" >
    </div>
  <div class="form-item">
    <label>小组人数<span style="color:red">*</span></label>
        <input
      v-model.number="createGroupForm.maxMember"
      type="number"
      min="2"
      :max="userMaxLimit"
      :placeholder="`2~${userMaxLimit}人`"
    >
  </div>
</div>
    <!-- ===================================== -->
    <div class="form-item">
      <label>小组类型</label>
      <div class="radio-group">
        <label>
    <input type="radio" v-model="createGroupForm.groupType" value="lover">
    <span>恋人伴侣</span>
  </label>
  <label>
    <input type="radio" v-model="createGroupForm.groupType" value="child">
    <span>亲子眷幼</span>
  </label>
  <label>
    <input type="radio" v-model="createGroupForm.groupType" value="parent">
    <span>孝亲伴老</span>
  </label>
  <label>
    <input type="radio" v-model="createGroupForm.groupType" value="other">
    <span>其他</span>
  </label>
        <select
          v-model="createGroupForm.otherSubType"
          :disabled="createGroupForm.groupType !== 'other'"
          class="other-select"
        >
          <option value="colleague">同事</option>
          <option value="friend">朋友</option>
          <option value="relative">亲戚</option>
          <option value="classmate">同学</option>
        </select>
      </div>
    </div>
    <div class="btn-group">
      <button @click="closeCreateGroupModal">取消</button>
      <button @click="handleCreateGroup">确认创建</button>
    </div>
  </div>
</div>


    <!-- ==========【功能开发提示弹窗 - 独立，不影响别的弹窗】 ========== -->
    <!-- ==========【年度报告专属提示弹窗】 ========== -->
    <div v-if="showReportTipPopup" class="tip-mask" @click="showReportTipPopup = false">
      <div class="tip-panel" @click.stop>
        <div class="tip-text">{{ reportTipMsg }}</div>
        <button class="tip-btn" @click="showReportTipPopup = false">确定</button>
      </div>
    </div>

  <!-- 操作成功提示弹窗，复用视频提示的样式体系 -->
<div v-if="showSuccessTip" class="tip-mask" @click="showSuccessTip=false">
  <div class="tip-panel" @click.stop>
    <div class="tip-text">{{successTipMsg}}</div>
    <button class="tip-btn" @click="showSuccessTip=false">确定</button>
  </div>
</div>

    <!-- ======【新增弹窗：输入邀请码加入小组】====== -->
    <div v-if="showJoinGroupModal" class="modal-mask" @click.self="closeJoinGroupModal">
      <div class="modal-box">
        <h3>输入邀请码加入小组</h3>
        <input v-model="inviteCode" type="text" placeholder="请输入小组邀请码" />
        <div class="tip-text">请输入组长提供的小组邀请码</div>
        <div class="btn-group">
          <button @click="closeJoinGroupModal">取消</button>
          <button @click="handleJoinGroup">确认加入</button>
        </div>
      </div>
    </div>
    <!-- ======【导出数据弹窗】====== -->
    <div v-if="showExportModal" class="modal-mask" @click.self="closeExportModal">
      <div class="modal-box export-modal-box">
        <h3>导出我的数据</h3>

        <!-- 选项 1：JSON -->
        <div class="export-option" @click="exportJSON">
          <div class="export-option-icon">📄</div>
          <div class="export-option-content">
            <div class="export-option-title">
              JSON 数据备份
              <span class="export-option-tag recommend">推荐</span>
            </div>
            <div class="export-option-desc">
              包含账号信息、个人足迹、我在各小组登记的足迹。
            </div>
            <div class="export-option-note">
              符合《个人信息保护法》查阅、复制要求，可随时备份留存
            </div>
          </div>
        </div>

        <!-- 选项 2：杂志（开发中） -->
        <div class="export-option disabled" @click="showMagazineTip">
          <div class="export-option-icon">📖</div>
          <div class="export-option-content">
            <div class="export-option-title">
              足迹杂志
              <span class="export-option-tag soon">开发中</span>
            </div>
            <div class="export-option-desc">
              精装排版，适合装订成册，永存美好记忆。
            </div>
            <div class="export-option-note">
              支持个人版 · 小组版 · 汇总版
            </div>
          </div>
        </div>

        <div class="btn-group">
          <button @click="closeExportModal">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

// 安全昵称池，用于首次随机生成昵称
const nickNamePool = [
  "山河行者", "风遇山河", "人间赴山海", "踏迹寻风", "云间旅人",
  "远途观山河", "山河留迹", "逐路远方", "行遍九州", "旷野行客"
]

export default {
  data() {
    return {
      bgImg: require('@/assets/grzx.webp'), // 个人中心固定背景
      userInfo: {
        avatar: "/default-avatar.webp",
        nickname: "",
        signature: ""
      },
      
      isGroupUser: false, // 是否小组账号（当前选中小组）
      currentUserObj: {},
      userMaxLimit: 5,
      // 原有单项编辑弹窗
      showNameModal: false,
      showDescModal: false,
      tempNickname: "",
      tempSignature: "",
      
      // ==========【新增 创建小组弹窗数据】==========
      showCreateGroupModal: false,
      createGroupForm: {
        maxMember: null,
        groupType: "lover",
        otherSubType: "",
        groupName: "" // 新增：小组自定义名称
      },

     showReportTipPopup: false, // 年报独立开关
     showSuccessTip: false,
     successTipMsg: '',
     reportTipMsg: '',

      // ==========【新增：邀请码加入小组】==========
      showJoinGroupModal: false,
      inviteCode: "",
      // ==========【新增：导出数据】==========
      showExportModal: false,
      exporting: false
    }
  },
  async mounted() {
    this.getUserInfo()
    this.getCurrentUserState()
   },
  methods: {
    getCurrentUserState() {
      const user = JSON.parse(localStorage.getItem("currentUser") || "{}")
      this.currentUserObj = user
      this.isGroupUser = !!user.groupId
    },
goMemories() {
  this.$router.push('/memories')
},
   showTip(msg) {
     this.successTipMsg = msg;
     this.showSuccessTip = true;
   },
    // ========== 数据导出 ==========
    openExportModal() {
      this.showExportModal = true
    },
    closeExportModal() {
      this.showExportModal = false
    },
    showMagazineTip() {
      this.$showToast('足迹杂志功能正在开发中，敬请期待', 'warning')
    },

    async exportJSON() {
      if (this.exporting) return
      this.exporting = true
      try {
        const userRes = await request.get('/user/current')
        const user = userRes.user || {}
        const myPhone = user.phone || ''

        // 个人足迹
        const personalFoot = await request.get('/footprint', { params: { groupId: 'personal' } })
        const personalList = (personalFoot.data || []).map(f => ({
          province: f.province,
          city: f.city,
          arriveTime: f.arriveTime,
          leaveTime: f.leaveTime,
          partner: f.partner,
          spots: f.spots,
          food: f.food,
          hotel: f.hotel,
          note: f.note,
          photoCount: (f.photoList || []).length,
          createTime: f.createTime
        }))

        // 我的小组 + 我在每组登记的足迹
        const myGroupsRes = await request.get('/group/my')
        const myGroups = myGroupsRes.data || []
        const groupData = []
        for (const g of myGroups) {
          const footRes = await request.get('/footprint', { params: { groupId: g.groupId } })
          const myFootInGroup = (footRes.data || [])
            .filter(f => f.createUserId === myPhone)
            .map(f => ({
              province: f.province,
              city: f.city,
              arriveTime: f.arriveTime,
              leaveTime: f.leaveTime,
              partner: f.partner,
              spots: f.spots,
              food: f.food,
              hotel: f.hotel,
              note: f.note,
              photoCount: (f.photoList || []).length,
              createTime: f.createTime
            }))
          groupData.push({
            groupName: g.groupName,
            groupType: g.groupType,
            otherSubType: g.otherSubType || '',
            isCreator: g.masterAccount === myPhone,
            myFootprintsInGroup: myFootInGroup
          })
        }

        // 组装 JSON
        const now = new Date()
        const pad = n => String(n).padStart(2, '0')
        const exportTime = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
        const maskPhone = p => p ? p.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2') : ''

        const exportData = {
          exportInfo: {
            exportTime,
            platform: '爱的印记',
            version: '1.0',
            description: '本文件为用户个人数据的完整导出，符合《个人信息保护法》查阅、复制要求。'
          },
          userProfile: {
            phone: maskPhone(myPhone),
            nickname: user.nickname || '',
            signature: user.signature || ''
          },
          personalFootprints: personalList,
          groups: groupData,
          statistics: {
            personalCount: personalList.length,
            groupCount: groupData.length,
            totalMyFootprints: personalList.length + groupData.reduce((s, g) => s + g.myFootprintsInGroup.length, 0)
          }
        }

        // 下载
        const jsonStr = JSON.stringify(exportData, null, 2)
        const blob = new Blob([jsonStr], { type: 'application/json;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `爱的印记-数据备份-${now.getFullYear()}${pad(now.getMonth()+1)}${pad(now.getDate())}.json`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)

        this.closeExportModal()
        this.$showToast('数据已导出，请妥善保存', 'success')
      } catch (err) {
        console.error('导出失败', err)
        this.$showToast('导出失败，请重试')
      } finally {
        this.exporting = false
      }
    },

    // 返回首页（全国地图）
    goBack() {
      this.$router.push({
        name: 'Index'
      })
    },
    // 获取用户信息：走后端
    async getUserInfo() {
      try {
        const res = await request.get('/user/current')
        if (res.success && res.user) {
          this.userInfo.nickname = res.user.nickname || '山河行者'
          this.userInfo.signature = res.user.signature || '山河留迹  身心相随'
          this.userInfo.avatar = res.user.avatar || '/default-avatar.webp'
          this.userMaxLimit = res.user.groupMaxNum || 5
          // 同步到本地缓存，海报页和其他页面能直接用
          localStorage.setItem('user', JSON.stringify({
            nickname: this.userInfo.nickname,
            signature: this.userInfo.signature,
            avatar: this.userInfo.avatar
          }))
        }
      } catch (err) {
        console.error('获取用户信息失败', err)
      }
    },
       // 保存用户信息到后端 + 本地缓存
    async saveUserToLocal() {
      try {
        await request.put('/user/current', {
          nickname: this.userInfo.nickname,
          signature: this.userInfo.signature,
          avatar: this.userInfo.avatar
        })
      } catch (err) {
        console.error('保存用户信息失败', err)
      }
      // 无论后端是否成功，本地缓存也同步更新
      localStorage.setItem('user', JSON.stringify({
        nickname: this.userInfo.nickname,
        avatar: this.userInfo.avatar,
        signature: this.userInfo.signature
      }))
    },
    // 【新增】跳转页面：查看我创建的小组
    goGroupCreatedListPage(){
      this.$router.push({
        path:"/GroupCreatedList"
      })
    },
    // 【新增】跳转页面：查看我加入的小组
    goGroupJoinedListPage(){
      this.$router.push({
        path:"/GroupJoinedList"
      })
    },
    // 辅助：小组类型转中文名称【已修改，去掉小组后缀，支持other子类型】
    getGroupTypeName(type, subType) {
      const map = {
        lover:"恋人伴侣",
        child:"亲子眷幼",
        parent:"孝亲伴老",
        other: {
          colleague:"同事",
          friend:"朋友",
          relative:"亲戚",
          classmate:"同学"
        }
      }
      if(type === 'other'){
        return map.other[subType] || "其他"
      }
      return map[type] || ""
    },
    // ========== 创建小组弹窗控制 ==========
    openCreateGroupModal() {
      this.showCreateGroupModal = true
      this.createGroupForm = {
        maxMember:null,
        groupType:"lover",
        otherSubType:"",
        groupName:"" // 重置小组名称
      }
    },
    closeCreateGroupModal() {
      this.showCreateGroupModal = false
    },
    // 【核心创建小组逻辑】
       // 【核心创建小组逻辑 - 走后端】
    async handleCreateGroup() {
      const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}")
      const phone = currentUser.phone
      if (!phone) {
        alert("请先登录账号！")
        return
      }
      const { maxMember, groupType,  otherSubType, groupName } = this.createGroupForm
      if (!maxMember) {
        alert("请填写小组人数");
        return;
      }
      if (maxMember < 2 || maxMember > this.userMaxLimit) {
        alert(`小组人数只能填写 2~${this.userMaxLimit} 人；如需更多请联系客服`);
        return;
      }
      if (groupType === 'other' && !otherSubType) {
        alert("请选择小组类别（同事/朋友/亲戚/同学）")
        return
      }
       const groupNameTrim = groupName.trim()
      if (!groupNameTrim) {
        alert("请填写小组自定义名称！")
        return
      }
      if (groupNameTrim.length > 6) {
        alert("小组名称不能超过6个字！")
        return
      }
      // ===== 敏感词校验 =====
      if (this.$hasSensitiveWord(groupNameTrim)) {
        this.$showToast('小组名称包含违规词汇，请修改')
        return
      }

      try {
        const res = await request.post('/group', {
          groupName: groupNameTrim,
          groupType,
          otherSubType: groupType === 'other' ? otherSubType : '',
          maxMember
        })
        if (!res.success) {
          alert(res.msg || '创建失败')
          return
        }
        // 更新 currentUser 的 groupIdList
        if (!Array.isArray(currentUser.groupIdList)) currentUser.groupIdList = []
        if (!currentUser.groupIdList.includes(res.data.groupId)) {
          currentUser.groupIdList.push(res.data.groupId)
        }
        currentUser.groupId = res.data.groupId
        currentUser.groupType = groupType
        localStorage.setItem("currentUser", JSON.stringify(currentUser))

        this.showTip("✅小组创建成功！")
        this.$nextTick(() => {
          this.closeCreateGroupModal()
        })
        
        this.getCurrentUserState()
      } catch (err) {
        console.error(err)
        alert('创建失败，请检查后端是否启动')
      }
    },

    // ==========【新增：加入小组邀请码逻辑】==========
    openJoinGroupModal() {
      this.showJoinGroupModal = true
      this.inviteCode = ""
    },
    closeJoinGroupModal() {
      this.showJoinGroupModal = false
    },
       async handleJoinGroup() {
      const code = String(this.inviteCode || '').trim().toUpperCase()
      if (!code) {
        alert("请输入邀请码！")
        return
      }
      const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}")
      const phone = currentUser.phone
      if (!phone) {
        alert("请先登录账号！")
        return
      }

      try {
        const res = await request.post('/group/join', { inviteCode: code })
        if (!res.success) {
          alert(res.msg || '加入失败')
          return
        }

        // 更新本地缓存的 groupIdList
        if (!Array.isArray(currentUser.groupIdList)) {
          currentUser.groupIdList = []
        }
        // 重新拉一遍我的小组列表，拿到刚加入的 groupId
        const myRes = await request.get('/group/my')
        if (myRes.success && Array.isArray(myRes.data)) {
          currentUser.groupIdList = myRes.data.map(g => g.groupId)
          localStorage.setItem("currentUser", JSON.stringify(currentUser))
        }

        this.closeJoinGroupModal()
        this.$nextTick(() => {
          this.showTip("✅成功加入小组！")
        })
        
      } catch (err) {
        console.error(err)
        alert('加入失败，请检查后端是否启动')
      }
    },

    // ========== 头像上传 ==========
    openAvatarUpload() {
      this.$refs.avatarInput.click()
    },
    async handleAvatarChange(e) {
      const file = e.target.files[0]
      if (!file) return
      if (!['image/jpeg', 'image/png'].includes(file.type)) {
        alert('仅支持jpg、png图片')
        return
      }
      if (file.size > 2 * 1024 * 1024) {
        alert('图片不能超过2MB')
        return
      }

      const img = new Image()
      const reader = new FileReader()
      reader.onload = (ev) => {
        img.src = ev.target.result
        img.onload = async () => {
          if (img.width < 80 || img.height < 80) {
            alert('图片最小尺寸80×80像素')
            return
          }
          try {
            const blob = await this.compressAvatar(img, 300, 0.85)
            const url = await this.uploadAvatarToServer(blob)
            this.userInfo.avatar = url
            await this.saveUserToLocal()
          } catch (err) {
            console.error('头像上传失败', err)
            alert('头像上传失败，请重试')
          }
        }
      }
      reader.readAsDataURL(file)
    },

    // 头像压缩：居中裁剪成正方形，压到 300×300
    compressAvatar(img, size, quality) {
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas')
        canvas.width = size
        canvas.height = size
        const ctx = canvas.getContext('2d')
        const minSide = Math.min(img.width, img.height)
        const sx = (img.width - minSide) / 2
        const sy = (img.height - minSide) / 2
        ctx.drawImage(img, sx, sy, minSide, minSide, 0, 0, size, size)
        canvas.toBlob(blob => resolve(blob), 'image/jpeg', quality)
      })
    },

    // 上传头像到后端
    uploadAvatarToServer(blob) {
      return new Promise(async (resolve, reject) => {
        try {
          const formData = new FormData()
          formData.append('file', blob, 'avatar.jpg')
          const res = await request.post('/uploadImage', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          if (res.success && res.url) {
            resolve(res.url)
          } else {
            reject(res.msg || '上传失败')
          }
        } catch (err) {
          reject(err)
        }
      })
    },

    // ========== 单项：修改昵称 ==========
    openNameEdit() {
      this.tempNickname = this.userInfo.nickname
      this.showNameModal = true
    },
    closeNameModal() {
      this.showNameModal = false
    },
    async saveNickname() {
      const val = this.tempNickname.trim()
      if(val.length <2 || val.length>12) {
        alert("昵称长度必须2~12个字")
        return
      }
      const reg = /^[\u4e00-\u9fa5a-zA-Z0-9_]+$/
      if(!reg.test(val)) {
        alert("昵称仅允许中文、英文、数字、下划线")
        return
      }
         // ===== 敏感词校验 =====
      if (this.$hasSensitiveWord(val)) {
        this.$showToast('昵称包含违规词汇，请修改')
        return
      }
      this.userInfo.nickname = val
      await this.saveUserToLocal()
      this.showNameModal = false
       },

    // ========== 单项：修改签名 ==========
    openDescEdit() {
      this.tempSignature = this.userInfo.signature
      this.showDescModal = true
    },
    closeDescModal() {
      this.showDescModal = false
    },
        async saveSignature() {
      const val = this.tempSignature.trim()
      if(val.length >15) {
        alert("签名最多15个字")
        return
      }
      // ===== 敏感词校验 =====
      if (val && this.$hasSensitiveWord(val)) {
        this.$showToast('签名包含违规词汇，请修改')
        return
      }
      this.userInfo.signature = val
      await this.saveUserToLocal()
      this.showDescModal = false
    },

    // 跳转年度印记报告（带严格的时间限制）
    goToAnnualReport() {
      const now = new Date();
      const month = now.getMonth() + 1; // 1-12
      const date = now.getDate();
      
      // 判断是否在 12月25日 到 次年2月底 之间
      let isOpen = false;
      if (month === 12 && date >= 25) isOpen = true; // 12.25 - 12.31
      if (month === 1 || month === 2) isOpen = true; // 次年 1.1 - 2.28/29
     

      if (isOpen) {
        // 如果时间符合，跳转到年报页
        this.$router.push('/annual-report');
      } else {
        this.reportTipMsg = "年度印记报告每年12月25日自动生成，12月底至次年2月为报告获取期。当前不在获取期内，敬请期待岁末年初的专属回顾。";
        this.showReportTipPopup = true;
      }
    },

    // 进入个人足迹页面
    goPersonalFootprint() {
      this.$router.push({
        path: "/personal-footprint"
      })
    },
    // 进入小组管理（复用已有小组管理页面，传入groupId）
    goGroupManage(groupId) {
      console.log('进入goGroupManage，groupId：', groupId)
      this.$router.push({
        path: '/groupManage',
       query: { id: groupId }
      })
    },
    // 进入足迹统计页面：自动区分个人/小组足迹
goStat() {
   this.$router.push({
    path: "/footprint-stat",
      })
},
    // 生成海报页面：【修改】直接跳转，数据校验交给poster页面内部
    goPoster() {
      this.$router.push({
        name: "PosterCreate"
      })
    },
    goAnniversary() {
      const userGroupIdList = this.currentUserObj.groupIdList || [];
      if (userGroupIdList.length === 0) {
        this.$showToast('请先创建或加入一个小组');
        return;
      }
      
      // 优先使用当前活跃的小组，如果没有，就默认取他加入的第一个小组
      const targetGroupId = this.currentUserObj.groupId || userGroupIdList[0];
      
      this.$router.push({
        path: '/anniversary',
        query: { id: targetGroupId }
      });
    },
  }
}
</script>

<style scoped>
/* ===== 1. 页面骨架：完美复用 Index.vue 的逻辑 ===== */
.container {
  width: 100%;
  height: calc(var(--vh, 1vh) * 100); /* 关键：解决移动端地址栏导致的高度计算问题 */
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.footprint-bg {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: #444654;
  background-size: cover;
  background-position: center;
  z-index: 0;
  pointer-events: none;
}

/* ===== 2. Header ===== */
.header {
  position: relative;
  z-index: 10; /* 确保悬浮在背景上 */
  flex-shrink: 0;
  /* 稍微加高一点点，更有呼吸感 */
  height: clamp(48px, 7vh, 68px); 
  display: flex;
  align-items: center;
  /* 左右留白，让胶囊不贴边 */
  padding: 0 clamp(16px, 3vw, 32px); 
  gap: clamp(8px, 1.5vw, 16px);
  box-sizing: border-box;
  
  /* 👇 核心：把整个导航栏做成一条横向的磨砂玻璃 */
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.05));
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
.back-btn {
  border-radius: 6px; 
  
  /* 👇 核心：上下 padding 为 0，高度完全靠字号撑开 */
  padding: 0 clamp(8px, 1.2vw, 14px); 
  height: clamp(24px, 3.2vh, 28px);
  
  /* 使用 inline-flex 让文字完美居中 */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.15));
  color: #fff;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.6);
  
  box-shadow: 
    0 2px 6px rgba(0, 0, 0, 0.1),
    inset 0 1px 2px rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  
  /* 字号自适应：最小11px，最大14px，行高设为 1.2 保持紧凑 */
  font-size: clamp(11px, 1.1vw, 14px);
  line-height: 1.2; 
  
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}

.back-btn:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.3));
  transform: translateY(-1px);
}

.back-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.15);
}
.header h2 {
  position: absolute !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 !important;
  color: #2c3e50 !important; 
  
  font-size: clamp(15px, 2.1vw, 22px) !important; 
  font-weight: 900 !important; 
  letter-spacing: 3px !important; 
  white-space: nowrap !important;
  pointer-events: none !important;
  line-height: 1.2 !important;
  
  text-shadow: 
    0 2px 4px rgba(255, 255, 255, 0.9),
    0 4px 12px rgba(255, 255, 255, 0.6),
    0 1px 0px rgba(255, 255, 255, 1) !important;
}

/* ===== 3. 核心外壳：用 Flex 纵向分配，绝对锁死高度 ===== */
.block-container {
  position: relative;
  z-index: 2;
  flex: 1; /* 占据 header 以外的所有高度 */
  display: flex;
  flex-direction: column;
  padding: clamp(18px, 2.3vw, 26px); 
  gap: clamp(16px, 3vh, 32px);
  overflow: hidden;
  box-sizing: border-box;
}

/* ===== 4. 顶部个人资料通栏 ===== */
.block-user-full {
  flex-shrink: 0; 
  min-height: clamp(60px, 12vh, 110px); /* 稍微加高一点点 */
  padding: clamp(10px, 1.5vw, 18px) clamp(16px, 2vw, 24px);
  margin-top: clamp(-20px, -2vh, -10px);
  background: linear-gradient(to bottom, rgba(255,255,255,0.15), rgba(255,255,255,0) 40%), 
              rgba(120, 144, 156, 0.75);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 
    0 12px 24px -6px rgba(0, 0, 0, 0.25),
    inset 0 2px 5px rgba(255, 255, 255, 0.5),
    inset 0 -2px 6px rgba(0, 0, 0, 0.15);
  
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.block-user-full .user-card { 
  gap: clamp(8px, 1.2vw, 12px); 
  margin-bottom: 0; 
  display: flex; 
  align-items: center; 
}
.block-user-full .avatar-box {
  width: clamp(34px, 4vw, 46px);
  height: clamp(34px, 4vw, 46px);
  margin-right: clamp(6px, 1vw, 12px);
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}
.block-user-full .username { 
  font-size: clamp(12px, 1.3vw, 14px); 
  font-weight: bold; 
  color: #fff; 
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  cursor: pointer; 
  margin-right: auto;
}
.block-user-full .user-desc { 
  font-size: clamp(10px, 1.1vw, 12px); 
  color: #eee; 
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  cursor: pointer; 
}
.block-user-full .tip-text-profile { 
  font-size: clamp(9px, 1vw, 11px); 
  color: #ccc; 
  white-space: nowrap; 
  flex-shrink: 0; 
  margin-left: auto;
}
.block-user-full .annual-report-btn,
.block-user-full .export-entry-btn {
  padding: clamp(2px, 0.5vw, 6px) clamp(6px, 1vw, 14px);
  font-size: clamp(10px, 1vw, 12px);
  border-radius: 8px;
  flex-shrink: 0;
}

.user-info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.info-row { display: flex; align-items: center; gap: 8px; width: 100%; }
.info-row .username { margin-right: auto; }

/* ===== 5. 下方 6 个豆腐块：用 Grid 3列x2行绝对平分剩余空间 ===== */
.block-grid-6 {
  flex: 1; /* 吃掉剩余的所有高度 */
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr); /* 绝对强硬的 2 行等分 */
  margin-top: clamp(12px, 2vh, 24px); 
  gap: clamp(14px, 2.5vh, 24px); 
  min-height: 0; /* 允许被压缩 */
}

/* 通用立体属性 */
.block-item {
  border-radius: 16px; /* 圆角稍微加大一点点，更柔和 */
  padding: clamp(12px, 2vw, 24px);
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
  

  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 
    0 12px 24px -6px rgba(0, 0, 0, 0.25), 
    inset 0 2px 5px rgba(255, 255, 255, 0.6), 
    inset 0 -2px 6px rgba(0, 0, 0, 0.15);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  
  /* 加一点点背景模糊，如果下面有背景图的话会透出来 */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

/* 悬浮交互 */
.block-item:hover {
  transform: translateY(-4px);
  box-shadow: 
    0 18px 30px -6px rgba(0, 0, 0, 0.35), 
    inset 0 2px 8px rgba(255, 255, 255, 0.8), 
    inset 0 -2px 6px rgba(0, 0, 0, 0.15);
}
.block-item:active {
  transform: translateY(2px);
  box-shadow: 
    0 4px 10px -2px rgba(0, 0, 0, 0.2), 
    inset 0 2px 10px rgba(0, 0, 0, 0.15);
}

/* 🎨 玻璃色号（采用双重背景：底层渐变+表层透白高光） */
/* 这种写法能透出底色，又像玻璃一样明亮 */
.block-user { 
  background: linear-gradient(to bottom, rgba(255,255,255,0.1), rgba(255,255,255,0) 40%), 
              rgba(120, 144, 156, 0.75); 
}
.block-footprint { 
  background: linear-gradient(to bottom, rgba(255,255,255,0.15), rgba(255,255,255,0) 40%), 
              rgba(103, 194, 58, 0.85); 
}
.block-group-leader { 
  background: linear-gradient(to bottom, rgba(255,255,255,0.15), rgba(255,255,255,0) 40%), 
              rgba(156, 39, 176, 0.85); 
}
.block-group-member { 
  background: linear-gradient(to bottom, rgba(255,255,255,0.15), rgba(255,255,255,0) 40%), 
              rgba(0, 188, 212, 0.85); 
}
.block-stat { 
  background: linear-gradient(to bottom, rgba(255,255,255,0.15), rgba(255,255,255,0) 40%), 
              rgba(230, 162, 60, 0.85); 
}
.block-poster { 
  background: linear-gradient(to bottom, rgba(255,255,255,0.15), rgba(255,255,255,0) 40%), 
              rgba(245, 108, 108, 0.85); 
}
.block-video { 
  background: linear-gradient(to bottom, rgba(255,255,255,0.15), rgba(255,255,255,0) 40%), 
              rgba(64, 158, 255, 0.85); 
}
/* 文字增加细微投影，让在浅色底上也能看清楚 */
.block-title {
  width: 100%;
  font-size: clamp(13px, 1.5vw, 18px);
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0,0,0,0.2);
  margin-bottom: clamp(2px, 0.5vh, 6px);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.block-desc {
  font-size: clamp(11px, 1.1vw, 13px);
  line-height: 1.3;
  color: rgba(255, 255, 255, 0.85); /* 副标题稍微透明一点，建立层级 */
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: 100%;
  text-align: center;
  margin-top: 8px; 
}
/* ===== 组按钮（明亮玻璃质感） ===== */
.group-btn-wrap {
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 1.5vh, 14px); /* 按钮之间也拉开一点距离 */
  height: 100%;
  justify-content: center;
}

.group-enter-btn,
.create-group-btn,
.join-group-btn {
  flex: 1;
  min-height: 0;
  padding: 2px clamp(8px, 1.5vw, 14px);
  font-size: clamp(12px, 1.2vw, 16px);
  border-radius: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: all 0.2s ease;
  
  /* 透亮的白玻璃 */
  background: linear-gradient(to bottom, rgba(255,255,255,0.4), rgba(255,255,255,0.1));
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 
    0 4px 12px rgba(0, 0, 0, 0.1),
    inset 0 1px 2px rgba(255, 255, 255, 0.8); /* 按钮自身也有高光 */
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  font-weight: 600;
  letter-spacing: 1.5px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2); /* 防止字看不清 */
}

.group-enter-btn:hover,
.create-group-btn:hover,
.join-group-btn:hover {
  background: linear-gradient(to bottom, rgba(255,255,255,0.6), rgba(255,255,255,0.2));
  transform: translateY(-2px);
  box-shadow: 
    0 6px 16px rgba(0, 0, 0, 0.15),
    inset 0 1px 3px rgba(255, 255, 255, 0.9);
}

.group-enter-btn:active,
.create-group-btn:active,
.join-group-btn:active {
  /* 按下时，让白色的高光稍微收敛一点点，透出底下的颜色，模拟按下去的物理凹陷 */
  background: linear-gradient(to bottom, rgba(255,255,255,0.2), rgba(255,255,255,0.4));
  transform: translateY(1px) scale(0.98); /* 除了往下走 1px，再加一点点缩小，手感更好 */
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.2); /* 按下时内部变暗，像真的按进去了 */
}
/* ============================================================
   矮屏兜底：保持 3 列，只压行高，绝不换列
   ============================================================ */
@media (max-height: 500px) {
  .block-container {
    grid-template-rows: auto repeat(6, minmax(48px, 1fr));
    gap: clamp(4px, 0.8vh, 8px);
    padding: clamp(18px, 2.3vw, 26px); 
  }
  .block-item { padding: clamp(4px, 0.8vw, 8px); }
  .block-title { font-size: clamp(11px, 1.3vw, 14px); }
  .block-desc  { font-size: clamp(9px, 1vw, 11px); line-height: 1.15; }
  .header { height: clamp(34px, 5vh, 44px); }
  .header h2 { font-size: clamp(13px, 1.6vw, 16px); }
}

/* 窄竖屏：仍 3 列 2 行，不 auto-fit */
@media (max-width: 600px) and (min-height: 501px) {
  .block-container {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto repeat(2, minmax(0, 1fr));
    grid-auto-rows: minmax(0, 1fr);
  }
}

/* ============================================================
   弹窗 / 表单 / 导出 / 年度报告按钮样式（终极提纯版）
   ============================================================ */
.modal-mask {
  position: fixed;
  left: 0; top: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-box {
  width: clamp(280px, 80vw, 450px) !important;
  max-height: 90vh !important; 
  overflow-y: auto !important;
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 420px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.98);
  border-radius: 16px;
  padding: clamp(12px, 2vh, 20px) clamp(14px, 2vw, 24px) !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
}

.modal-box h3 {
  margin: 0 0 clamp(6px, 1vh, 12px) 0 !important;
  font-size: clamp(15px, 1.8vw, 18px) !important;
  color: #333 !important;
  font-weight: 700;
}

.modal-box input,
.modal-box textarea {
  width: 100%;
  box-sizing: border-box;
  height: clamp(30px, 4.5vh, 42px) !important;
  font-size: clamp(12px, 1.2vw, 14px) !important;
  padding: 0 clamp(8px, 1.5vw, 12px) !important;
  border: 1px solid #ccc;
  border-radius: 6px !important;
  margin-bottom: clamp(6px, 1vh, 10px) !important;
}
.modal-box textarea {
  padding: clamp(6px, 1vh, 10px) clamp(8px, 1.5vw, 12px) !important;
  min-height: clamp(60px, 10vh, 80px) !important;
  resize: none;
}

.modal-box .tip-text {
  font-size: clamp(11px, 1vw, 13px) !important;
  margin-bottom: clamp(8px, 1.2vh, 12px) !important;
  color: #666 !important;
  line-height: 1.3 !important;
}

/* ===== 弹窗按钮组 ===== */
.btn-group { 
  display: flex; 
  gap: clamp(10px, 2vw, 16px); 
  justify-content: center; 
  margin-top: clamp(10px, 2vh, 16px);
}
.btn-group button {
  padding: clamp(3px, 0.8vh, 6px) clamp(16px, 3vw, 28px);
  font-size: clamp(12px, 1.2vw, 14px);
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  
  /* 灰色琉璃 */
  background: linear-gradient(to bottom, rgba(255,255,255,0.4), rgba(255,255,255,0.1)), rgba(144, 147, 153, 0.85);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1), inset 0 1px 2px rgba(255, 255, 255, 0.6);
}
.btn-group button:last-child {
  /* 红色琉璃 */
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(209, 74, 74, 0.85);
  box-shadow: 0 3px 8px rgba(209, 74, 74, 0.2), inset 0 1px 2px rgba(255, 255, 255, 0.5);
}
.btn-group button:hover { transform: translateY(-1px); box-shadow: 0 5px 12px rgba(0, 0, 0, 0.15), inset 0 1px 3px rgba(255, 255, 255, 0.8); }
.btn-group button:active { transform: translateY(1px) scale(0.96); box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2); }

/* 表单和单选框 */
.form-item { margin-bottom: clamp(6px, 1.2vh, 12px) !important; }
.form-item label { display: block; font-size: clamp(12px, 1.2vw, 14px) !important; margin-bottom: clamp(4px, 0.8vh, 6px) !important; }
.form-row-two { display: flex; gap: clamp(8px, 2vw, 16px) !important; }
.form-row-two .form-item { flex: 1; }

.radio-group { display: flex; margin: 6px 0; width: 100%; gap: clamp(4px, 1vw, 10px) !important; justify-content: center; align-items: flex-start; }
.radio-group label { font-size: clamp(11px, 1.1vw, 13px) !important; text-align: center; padding-top: clamp(18px, 2.5vw, 24px) !important; cursor: pointer; position: relative; }
.radio-group input[type="radio"] { position: absolute; opacity: 0; }
.radio-group label::before { content: ''; position: absolute; top: 0; left: 50%; transform: translateX(-50%); width: clamp(12px, 1.5vw, 15px) !important; height: clamp(12px, 1.5vw, 15px) !important; border-radius: 50%; border: 1px solid #999; background: #fff; }
.radio-group input[type="radio"]:checked + span::after { content: ''; position: absolute; top: clamp(4px, 0.6vw, 5px) !important; left: 50%; transform: translateX(-50%); width: clamp(6px, 0.8vw, 7px) !important; height: clamp(6px, 0.8vw, 7px) !important; border-radius: 50%; background: #1677ff; }

/* 导出弹窗特殊样式 */
.export-modal-box { width: clamp(280px, 80vw, 480px) !important; padding: clamp(8px, 1.5vh, 14px) clamp(12px, 2vw, 20px) !important; }
.export-option { display: flex; gap: clamp(6px, 1vw, 10px); padding: clamp(8px, 1.2vh, 12px); background: rgba(255,255,255,0.7); border: 1px solid rgba(0,0,0,0.05); border-radius: 10px; margin-bottom: clamp(6px, 1vh, 10px); cursor: pointer; }
.export-option:hover { border-color: #409eff; background: rgba(255,255,255,0.95); transform: translateY(-1px); }
.export-option.disabled { opacity: 0.75; cursor: not-allowed; }
.export-option.disabled:hover { border-color: rgba(0,0,0,0.05); background: rgba(255,255,255,0.7); transform: none; }
.export-option-icon { font-size: clamp(20px, 2.5vw, 26px); }
.export-option-title { font-size: clamp(12px, 1.3vw, 14px); font-weight: bold; display: flex; gap: 6px; align-items: center; }
.export-option-desc { font-size: clamp(10px, 1.1vw, 12px); color: #555; }
.export-option-note { font-size: clamp(9px, 1vw, 11px); color: #888; }

/* 顶部两个高光按钮 */
.annual-report-btn, .export-entry-btn { padding: clamp(2px, 0.5vw, 6px) clamp(8px, 1.2vw, 14px); font-size: clamp(10px, 1vw, 12px); font-weight: 600; border-radius: 8px; cursor: pointer; flex-shrink: 0; border: 1px solid rgba(255,255,255,0.4); color: #fff; transition: all 0.2s ease; text-shadow: 0 1px 2px rgba(0,0,0,0.15); }
.annual-report-btn { background: linear-gradient(to bottom, rgba(255,255,255,0.2), transparent 50%), rgba(214, 72, 107, 0.85); box-shadow: 0 4px 12px rgba(214, 72, 107, 0.25), inset 0 1px 2px rgba(255,255,255,0.5); }
.export-entry-btn { background: linear-gradient(to bottom, rgba(255,255,255,0.25), transparent 50%), rgba(82, 196, 26, 0.85); box-shadow: 0 4px 12px rgba(82, 196, 26, 0.25), inset 0 1px 2px rgba(255,255,255,0.6); }

/* 提示面板 */
.tip-mask { position: fixed; inset: 0; background: rgba(0,0,0,0.32); z-index: 999; display: flex; align-items: center; justify-content: center; }
.tip-panel { min-width: 260px; max-width: 320px; padding: 24px; background-image: url("~@/assets/subtle.webp"); background-color: rgba(247,243,233,0.98); border-radius: 22px; text-align: center; box-shadow: 0 10px 30px rgba(0,0,0,0.18); }
.tip-btn { padding: clamp(3px, 0.8vh, 6px) clamp(16px, 3vw, 28px); font-size: clamp(12px, 1.2vw, 14px); border-radius: 6px; font-weight: 600; cursor: pointer; color: #fff; border: 1px solid rgba(255,255,255,0.3); background: linear-gradient(to bottom, rgba(255,255,255,0.25), transparent 50%), rgba(209,74,74,0.85); box-shadow: 0 3px 8px rgba(209,74,74,0.2), inset 0 1px 2px rgba(255,255,255,0.5); }

/* ===== 修复：独立提示弹窗的排版 ===== */
.tip-panel {
  min-width: clamp(200px, 60vw, 280px);
  padding: clamp(16px, 2.5vh, 24px) clamp(20px, 3vw, 32px);
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 420px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.98);
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(12px, 2vh, 20px); /* 文字和按钮拉开一点距离 */
}

/* 这里的文字，必须用小号、居中、带点灰色 */
.tip-panel .tip-text {
  font-size: clamp(13px, 1.3vw, 15px) !important; /* 👈 强制锁死字号 */
  color: #383838 !important;
  line-height: 1.5;
  margin-bottom: 0 !important;
  text-align: center;
  font-family: "Microsoft YaHei", sans-serif;
  /* 如果有长文本，让它自动换行且不撑破 */
  word-break: break-all; 
}

/* 弹窗里的按钮（红色琉璃） */
.tip-panel .tip-btn {
  padding: clamp(4px, 0.8vh, 6px) clamp(20px, 3vw, 32px);
  font-size: clamp(12px, 1.2vw, 14px);
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), transparent 50%), rgba(209,74,74,0.85);
  box-shadow: 0 3px 8px rgba(209,74,74,0.2), inset 0 1px 2px rgba(255,255,255,0.5);
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.tip-panel .tip-btn:hover {
  transform: translateY(-1px);
}
.tip-panel .tip-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.2);
}
</style>